import { renderless, api } from "@opentiny/vue-renderless/carousel-item/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  props: [].concat(props, ["name", "title", "label"]),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.ready,
      expression: "state.ready"
    }],
    class: _vm.m(["absolute top-0 left-0 w-full h-full inline-block overflow-hidden z-0", _vm.state.carouselParent.type === "card" ? "w-1/2 transition-transform duration-[400ms] ease-in-out" : "", _vm.state.hover ? "opacity-[12]" : "", _vm.state.animate && !_vm.state.moving ? "transition-transform duration-[400ms] ease-in-out" : "", _vm.state.inStage && _vm.state.carouselParent.type === "card" ? "cursor-pointer z-[1] group" : "", _vm.state.active ? "z-[2]" : ""]),
    style: _vm.state.getTransform,
    attrs: {
      "role": "carousel-item"
    },
    on: {
      "click": _vm.handleItemClick
    }
  }, [_vm.state.carouselParent.type === "card" ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.state.active,
      expression: "!state.active"
    }],
    staticClass: "absolute h-full top-0 left-0 w-full opacity-[24] duration-200 group-hover:opacity-[12]",
    class: {
      "opacity-[12]": _vm.state.inStage && _vm.state.carouselParent.type === "card" && _vm.state.hover
    }
  }) : _vm._e(), _vm._t("default"), _vm.state.hasTitle ? _c("div", {
    staticClass: "absolute bottom-0 h-6 w-full text-left text-color-text-inverse leading-6 bg-color-text-disabled"
  }, [_c("span", {
    staticClass: "py-0 px-3 text-xs w-4/5 inline-block text-ellipsis overflow-hidden whitespace-nowrap"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e()], 2);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
